<template>
  <span :class="className">
    <svg :width="width" :height="height" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.87802 1.56831L7.56984 1.42125L0.108564 8.75636C-0.0359333 8.89841 -0.0362252 9.13099 0.107914 9.27341L0.736971 9.89494C0.879386 10.0357 1.10894 10.0349 1.25046 9.89332L8.61551 2.52379L8.47198 6.24145V9.11614C8.47198 9.31651 8.63462 9.47941 8.83582 9.47941H9.63616C9.83736 9.47941 10 9.31651 10 9.11614V0.363265C10 0.162894 9.83736 0 9.63616 0H0.876598C0.675397 0 0.512754 0.162894 0.512754 0.363264V1.20504C0.512754 1.40541 0.675397 1.56831 0.876597 1.56831H3.87802Z"
        :fill="fillColor"
      />
    </svg>
  </span>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'LinkArrow',
  props: {
    width: {
      type: String,
      default: '10px'
    },
    height: {
      type: String,
      default: '10px'
    },
    className: {
      type: String,
      default: ''
    },
    fillColor:{
      type: String,
      default:'#667488'
    },
  }
}
</script>
